module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0106.jpg?v=8c300af5";